import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {
  IMyDashboardResponseBootcampProgress,
  IMyDashboardResponseSongsProgress,
  MyDashboardResponseNotesPlayedType,
  MyDashboardResponsePlayingTimeType
} from "../../../client/models/myDashboard/IMyDashboardResponse";

import {
  DashboardTimeRangeOptionType,
  IDashboardPageLastPlayed,
  IDashboardPageRecentlyPlayed,
  IDashboardPageStore,
  IDashboardPageUserSummary
} from "./IDashboardPageStore";


const initialState: IDashboardPageStore = {
};

export interface IDashboardLoadPayload {
  lastPlayed?: Optional<IDashboardPageLastPlayed>;
  userSummary?: Optional<IDashboardPageUserSummary>;
  recentlyPlayed?: Optional<IDashboardPageRecentlyPlayed>;
  playingTime?: Optional<MyDashboardResponsePlayingTimeType>;
  notesPlayed?: Optional<MyDashboardResponseNotesPlayedType>;
  bootcampProgress?: Optional<IMyDashboardResponseBootcampProgress>;
  songsProgress?: Optional<IMyDashboardResponseSongsProgress>;
}

export const dashboardPageSlice = createSlice({
  name: `dashboardPage`,
  initialState,

  reducers: (create) => ({
    requestStatusReducer: create.reducer(
      (store: IDashboardPageStore, action: PayloadAction<"loading" | "error" | "completed">) => {
        store.requestStatus = action.payload;
      }
    ),

    loadDashboardPageReducer: create.reducer(
      (store: IDashboardPageStore, action: PayloadAction<IDashboardLoadPayload>) => {
        const {userSummary, lastPlayed, recentlyPlayed, notesPlayed, playingTime, bootcampProgress, songsProgress} = action.payload;
        store.userSummary = userSummary;
        store.lastPlayed = lastPlayed;
        store.recentlyPlayed = recentlyPlayed;
        store.notesPlayed = {...(store.notesPlayed ?? {}), byRange: notesPlayed ? {...notesPlayed,} : undefined};
        store.playingTime = {...(store.playingTime ?? {}), byRange: playingTime ? {...playingTime,} : undefined};
        store.bootcampProgress = bootcampProgress;
        store.songsProgress = songsProgress;
      }
    ),

    notesPlayedRangeReducer: create.reducer((store: IDashboardPageStore, action: PayloadAction<DashboardTimeRangeOptionType>) => {
      const selectedRange = action.payload;
      return {
        ...store,
        notesPlayed: {
          ...(store.notesPlayed ?? {}),
          selectedRange,
        },
      } as IDashboardPageStore;
    }),

    playingTimeRangeReducer: create.reducer(
      (store: IDashboardPageStore, action: PayloadAction<DashboardTimeRangeOptionType>) => {
        const selectedRange = action.payload;
        return {
          ...store,
          playingTime: {
            ...(store.playingTime ?? {}),
            selectedRange,
          },
        } as IDashboardPageStore;
      }
    ),

    clearDashboardPageReducer: create.reducer(() => {
      return {
        ...initialState,
      };
    }),

    isInfoModalVisibleReducer: create.reducer((store: IDashboardPageStore, action: PayloadAction<boolean>) => {
      store.isInfoModalVisible = action.payload;
    })
  }),

  selectors: {
    bootcampProgressSelector: (state: IDashboardPageStore) => state.bootcampProgress,
    notesPlayedSelector: (state: IDashboardPageStore) => state.notesPlayed,
    requestStatusSelector: (state: IDashboardPageStore) => state.requestStatus,
    userSummarySelector: (state: IDashboardPageStore) => state.userSummary,
    lastPlayedSelector: (state: IDashboardPageStore) => state.lastPlayed,
    recentlyPlayedSelector: (state: IDashboardPageStore) => state.recentlyPlayed,
    playingTimeSelector: (state: IDashboardPageStore) => state.playingTime,
  }
});

export const dashboardPageReducer = dashboardPageSlice.reducer;
